import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-plugin-mobx';
import { useEffect } from 'react';

import { MultiItemStore } from 'stores/multi-item-store';
import { SearchResultsStore } from 'stores/search-results-store';
import { UIPageStore } from 'stores/ui-page-store';

interface UseSecondaryFetchStatusType {
  context: ContextStore;
  multiItem?: MultiItemStore;
  searchResults: SearchResultsStore;
  experiment?: ExperimentStore;
  uiPage?: UIPageStore;
  analytics?: AnalyticsStore;
}

export default function useSecondaryFetchStatus({
  searchResults,
  analytics,
  context,
  multiItem,
  uiPage,
  experiment,
}: UseSecondaryFetchStatusType) {
  const REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET = experiment?.exposures?.Reduced_Number_of_SRP_Listings?.bucket || 0;
  const REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING =
    REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET > 0 && searchResults.isFetchSecondaryListingBatch(REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET);

  useEffect(() => {
    if (
      REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET > 0 &&
      REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING &&
      !searchResults.isLoading &&
      analytics &&
      multiItem &&
      uiPage
    ) {
      const size = SearchResultsStore.REDUCED_NUMBER_OF_SRP_LISTINGS_SECONDARY_FETCH_COUNT_BY_BUCKET(REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET);
      const startingIndex = SearchResultsStore.REDUCED_NUMBER_OF_SRP_LISTINGS_INITIAL_FETCH_COUNT_BY_BUCKET(
        REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET
      );
      searchResults.showItemsByPage(analytics, context, multiItem, uiPage, { size, startingIndex }, experiment, false);
    }
  }, [REDUCED_NUMBER_OF_SRP_LISTINGS_BUCKET, REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING]);

  return REDUCED_NUMBER_OF_SRP_LISTINGS_IS_SECONDARY_FETCHING;
}
